export default  {"src":"/_next/static/image/public/assets/icons/yes-circle.99f84a04ae39b8b314b16817d598a7f2.svg","height":25,"width":25};